var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('script',{attrs:{"type":"application/javascript","src":"https://alcdn.msauth.net/browser/2.14.2/js/msal-browser.min.js"},on:{"load":_vm.authLoaded}})])}
var staticRenderFns = []

export { render, staticRenderFns }